// @flow

export function checkUrl (regex: ?string, url: string, checkSearchQuery: boolean = true): boolean {
  if (!url || !regex) return true

  const urlObject = new URL(url)
  const regExp = new RegExp(regex)
  return regExp.test(urlObject.pathname) || (checkSearchQuery && regExp.test(urlObject.search))
}
